import React from 'react';
import { Link } from '../components/LocalizedLink';
import { useLocation } from 'react-router-dom';
import { getLangFromPath, DATE_LOCALE } from '../i18n/langs';
import { blogUi, localizePost } from '../data/blogTranslations';
import { Calendar, Tag, User } from 'lucide-react';
import { SEO } from '../lib/seo';
import { blogPosts } from '../data/blogPosts';

const Blog: React.FC = () => {
  // Artículos locales (ya no dependen de Supabase)
  const location = useLocation();
  const lang = getLangFromPath(location.pathname);
  const ui = blogUi[lang];
  const posts = [...blogPosts].sort((x, y) => y.date.localeCompare(x.date)).map((p) => localizePost(p, lang));

  if (posts.length === 0) {
    return (
      <div className="py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-8">{ui.heading}</h1>
          <div className="text-center text-gray-600">
            <p>{ui.empty}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <SEO 
        title={ui.seoTitle}
        description={ui.seoDescription}
        canonical="/blog"
        type="website"
      />
      <div className="py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-8">{ui.heading}</h1>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts.map((post) => (
              <article key={post.id} className="bg-white rounded-lg shadow-lg overflow-hidden">
                <img
                  src={post.image}
                  alt={post.imageAlt}
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <div className="flex items-center gap-4 text-sm text-gray-500 mb-4">
                    <span className="flex items-center gap-1">
                      <Calendar className="w-4 h-4" />
                      {new Date(post.date).toLocaleDateString(DATE_LOCALE[lang], {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })}
                    </span>
                    <span className="flex items-center gap-1">
                      <User className="w-4 h-4" />
                      {post.author}
                    </span>
                  </div>
                  <h2 className="text-xl font-bold mb-2">
                    <Link to={`/blog/${post.slug}`} className="hover:text-yellow-500 transition-colors">
                      {post.title}
                    </Link>
                  </h2>
                  <p className="text-gray-600 mb-4">{post.excerpt}</p>
                  <div className="flex flex-wrap gap-2">
                    {post.tags.map((tag, index) => (
                      <span
                        key={index}
                        className="inline-flex items-center gap-1 bg-gray-100 px-3 py-1 rounded-full text-sm text-gray-600"
                      >
                        <Tag className="w-3 h-3" />
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Blog;